var $6e2bc1641b0a0026$exports = {};
document.addEventListener('DOMContentLoaded', function() {
    const elements = document.querySelectorAll('[data-animation]');
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const element = entry.target;
            // Динамічний поріг залежно від ширини екрану
            // const screenWidth = window.innerWidth;
            // const threshold = screenWidth < 1440 ? 0.2 : 0.3; // 10% або 50% елемента видно
            // const threshold = 0.1; // 10% або 50% елемента видно
            const threshold = 0.2; // 10% або 50% елемента видно
            let showCondition = entry.intersectionRatio >= threshold;
            if (showCondition) {
                element.classList.add('animate-start');
                observer.unobserve(element); // Відключаємо спостерігач для елемента
            }
        });
    }, {
        threshold: [
            0,
            0.25,
            0.5,
            0.75,
            1
        ]
    });
    // Підключаємо спостерігач до елементів
    elements.forEach((element)=>observer.observe(element));
});


//# sourceMappingURL=pages.d6f5ef81.js.map
